import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { loadableReady } from '@loadable/component';

import App from './App';
import { initXdmExperiment } from './XDM';

loadableReady(() => {
  hydrateRoot(
    document.getElementById('root'),
    <BrowserRouter>
      <HelmetProvider>
        <App data={window.__INITIAL_STATE__} />
      </HelmetProvider>
    </BrowserRouter>,
  );

  // XDM experiment: only initialize (script injection) for allowlisted Route Operator ids.
  // No XDM logging here.
  try {
    initXdmExperiment();
  } catch (e) {
    // no-op
  }
});
if (module.hot && process.env.NODE_ENV === 'development') {
  //whenever a new verison of App.js is available use it
  module.hot.accept('./App', () => {
    const UpdatedApp = require('./App').default;
    loadableReady(() => {
      hydrateRoot(
        document.getElementById('root'),
        <BrowserRouter>
          <HelmetProvider>
            <UpdatedApp data={window.__INITIAL_STATE__} />
          </HelmetProvider>
        </BrowserRouter>,
      );
    });
  });
}
